// Copyright © Veeam Software Group GmbH

import { useEffect, useMemo } from 'react';

import type { CollectionSorting } from '@veeam/components';
import type React from 'react';
import type { SubheaderType } from 'pages/ExplorePage/components/ExploreGrid/enums/subheader-type';
import type { Node } from 'services';
import type { ExploreSortKeys } from 'services/explore/enums/explore-sort-keys';

import { ExploreGridModel } from 'pages/ExplorePage/models/explore-grid-model';
import { itemsLoader } from 'pages/ExplorePage/components/ExploreGrid/helpers/items-loader';


export function useExploreGridModel(
    node: Node,
    setAsyncLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setSubheaderType: React.Dispatch<React.SetStateAction<SubheaderType>>,
    sorting?: CollectionSorting<ExploreSortKeys>[],
): ExploreGridModel {
    const model = useMemo(() => new ExploreGridModel(itemsLoader, node, setAsyncLoading, setSubheaderType, sorting), []);

    useEffect(() => () => model.destroy(), []);

    return model;
}
